import React from 'react';

import Form from '../../../components/molecules/Form';
import ConfigurationUploadTemplate from './ConfigurationUploadTemplate';
import IForm from '../../../types/IForm';
import { IParameterProperty } from '../../../types/IParameter';

function getFileConstraints(name: string, params: IParameterProperty[] | undefined): string[] {
  if (params) {
    const fileParam = params.find(param => param.name === name);

    if (fileParam) {
      return fileParam.constraints?.fileExtensions || [];
    }
  }

  return [];
}

type ConfigurationUploadProperties = {
  form: IForm;
  name: string;
  namespace: string;
};

export default function ConfigurationUpload({ form, name, namespace }: ConfigurationUploadProperties) {
  return (
    <div className="configuration-file-upload">
      <Form id="configuration-file-upload-form" model={form}>
        <ConfigurationUploadTemplate
          fileExtensions={getFileConstraints(name, form?.params)}
          name={name}
          namespace={namespace}
        />
      </Form>
    </div>
  );
}
